import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ProductService } from 'src/app/services/product.service';
import { ApiPagination } from '@mobileia/core';
import { SectionService } from 'src/app/services/section.service';
import { FeaturedCategory } from 'src/app/entities/featured-category';
import { Product } from 'src/app/entities/product';
import { Slider } from '@mobileia/slider';
import { SliderService } from 'src/app/services/slider.service';
import { MetatagService } from 'src/app/services/metatag.service';
import { CategoryService } from 'src/app/services/category.service';
import { DragScrollComponent } from 'ngx-drag-scroll';
import { interval } from 'rxjs';
import { map } from 'rxjs/operators';
import { CartService } from 'src/app/services/cart.service';
import { slugify } from 'src/app/utils/string.utils';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  bestCategories = [];
  products:any = [];

  offertProducts:any = [];

  slider = new Array<Slider>();
  activeSlideIndex = 0;

  featuredCategories = new Array<FeaturedCategory>();

  productsFeatured = new ApiPagination<Product>();
  //productsSells = new ApiPagination<Product>();
  //productsViews = new ApiPagination<Product>();

  emailNewsletter = '';

  constructor(
    protected sliderService: SliderService,
    protected productService: ProductService,
    protected sectionService: SectionService,
    protected metatagService: MetatagService,
    protected categoryService: CategoryService,
    protected cartService: CartService
  ) { }

  ngOnInit() {
    this.metatagService.configSlug('home');
    this.loadSlider();
    this.loadFeatured();
    this.loadProducts();
    this.loadCategories();

    this.cartService.fetchList().subscribe();
  }

  @Input() specialDay = '';

  loadSlider() {
    this.sliderService.fetchActive().toPromise().then(data => {
      if (data.success) {
        this.slider = data.response;
        this.configSlider();
      }
    });
  }

  loadFeatured() {
    this.sectionService.fetchTwoProductFeature().toPromise().then(data => {
      if (data.success) {
        this.featuredCategories = data.response.data;
      }
    });
  }

  loadProducts() {
    this.productService.fetchListOrderByLastFeatured().toPromise().then(data => {
      if (data.success) {
        this.productsFeatured = data.response;
      }
    });
    this.productService.fetchInOffer().toPromise().then(data => {
      if (data.success) {
        this.offertProducts = data.response;
      }
    });
  }

  clickNewsletter() {
    this.sectionService.subscribeNewsletter(this.emailNewsletter).toPromise().then(data => {
      if (!data.success) {
        alert(data.error.message);
        return;
      }
      this.emailNewsletter = '';
      alert('Se ha guardado correctamente.');
    });
  }

  loadCategories() {
    this.categoryService.fetchFeatured().toPromise().then(data => {
      if (data.success) {
        this.bestCategories = data.response;
      }
    });
  }

  getPrice(product: Product) {
    return Product.getPrice(product);
  }

  getPriceWithoutDiscount(product: Product) {
    return Product.getPriceWithoutDiscount(product);
  }

  @Input('scrollbar-hidden') state = true;

  @ViewChild('headerCarousel', {read: DragScrollComponent}) ds: DragScrollComponent;

  moveLeft() {
    if(this.ds.currIndex == 0){
      this.ds.moveTo(this.slider.length-1);
    } else {
      this.ds.moveLeft();
    }

  }

  moveRight() {
    if(this.ds.currIndex == this.slider.length-1){
      this.ds.moveTo(0);
    } else {
      this.ds.moveRight();
    }
  }

  configSlider() {
    interval(5000).pipe(map(result => {
      if(this.ds.currIndex == this.slider.length-1){
        this.ds.moveTo(0);
      } else {
        this.ds.moveRight()
      }
    })).subscribe();
  }

  clickSlider(item) {
    this.sliderService.sumClick(item.id).toPromise().then(data => {});
    window.location.href = item.url_link;
  }

  onClickLink(url) {
    window.location.href = url;
  }

  processProductTitle(product) {
    return slugify(product.title);
  }
}
